import rules from "../rules";

export default {
    full_name: [
        rules.required('Name')
    ],
    dob: [
        rules.required('Birthdate'),
        (dob) => (dob !== 'INVALID_FORMAT') ? ((dob !== 'INVALID_AGE') ? true : "The DOB must be less than 99 years!") : "Please enter valid date in format(\"MM/DD/YYYY\")"
    ],
    gender: [
        rules.required('Gender')
    ],
    height: [
        rules.required('Height')
    ],
    weight: [
        rules.required('Weight'),
        (weight) => (weight >= 10 && weight <= 999) ? true : "Please enter valid weight"
    ],
    shoe_size: [
        rules.required('Shoe size')
    ],
    skier_type: [
        rules.required('Skier type')
    ],
    package_id: [
        rules.required('Package')
    ],
    snowboard_type: [
        rules.required('Snowboard Stance')
    ]

}
